module.exports = __webpack_public_path__ + "static/media/BIM 360 Team.f5b68893.png";